import config from './config';

export const isZigzinShop = (shopId: string) => {
  return shopId === '20017' || shopId === '9038';
};

export const getZigzinShopId = () => {
  const is_alpha = config.app_scheme === 'fbk-alpha';
  return is_alpha ? '20017' : '9038';
};
